import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { request } from '@/api/service';
export default {
  data: function data() {
    return {
      api: {
        index: 'DEVICE_RECHARGE_CONFIG_ALL',
        delete: 'DEVICE_RECHARGE_CONFIG_DELETE'
      },
      activeTab: 'template',
      emailConfig: {
        smtpHost: '',
        smtpPort: '',
        email: '',
        email_password: ''
      },
      emailTemplate: "",
      queryForm: {
        user_email: '',
        dateRange: '',
        email_type: ''
      },
      emailList: [],
      currentPage: 1,
      // 设备列表相关数据
      deviceList: [],
      deviceCurrentPage: 1,
      devicePageSize: 10,
      deviceTotal: 0,
      deviceDialogVisible: false,
      currentDevice: {
        device_id: '',
        device_name: '',
        device_address: '',
        email_send: false
      },
      pageSize: 10,
      total: 3,
      // 模板相关数据
      templateList: [],
      templateCurrentPage: 1,
      templatePageSize: 5,
      templateTotal: 0,
      templateDialogVisible: false,
      templateDialogTitle: '新增模板',
      createDialogVisible: false,
      newTemplate: {
        email_keys: '{"pick_code": "", "device_address": "", "save_user_phone":""}',
        email_title: 'Pick Code',
        email_type: 'Send code',
        email_language: 'en',
        // 在现有模板中添加图片链接
        email_template: "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n    <meta charset=\"UTF-8\">\n    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n    <title>Pickup Code Email</title>\n    <style>\n        body {\n            font-family: Arial, sans-serif;\n            line-height: 1.6;\n            color: #333;\n            background-color: #f5f7fa;\n            margin: 0;\n            padding: 20px;\n        }\n        .email-container {\n            max-width: 600px;\n            margin: 0 auto;\n            background: #ffffff;\n            border-radius: 8px;\n            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\n            padding: 30px;\n        }\n        .email-header {\n            text-align: center;\n            border-bottom: 1px solid #ebeef5;\n            padding-bottom: 20px;\n            margin-bottom: 20px;\n        }\n        .email-content {\n            margin-bottom: 20px;\n        }\n        .code-section {\n            background-color: #f8f9fa;\n            padding: 15px;\n            border-radius: 4px;\n            text-align: center;\n            font-size: 18px;\n            font-weight: bold;\n            color: #2c3e50;\n            margin: 20px 0;\n        }\n        .info-section {\n            margin: 20px 0;\n        }\n        .contact-info {\n            margin-top: 30px;\n            padding-top: 20px;\n            border-top: 1px solid #ebeef5;\n            font-size: 14px;\n            color: #666;\n        }\n        .logo {\n            width: 100px;\n            height: 100px;\n            display: block;\n            margin: 20px auto;\n        }\n    </style>\n</head>\n<body>\n    <div class=\"email-container\">\n        <div class=\"email-header\">\n            <h1>Pickup Notification</h1>\n        </div>\n        \n        <div class=\"email-content\">\n            \n            <div class=\"code-section\">\n                [BWZN] Pickup code %(pick_code)s\n            </div>\n            \n            <div class=\"info-section\">\n                <p>Please collect your key via smart locker at:</p>\n                <p><strong>%(device_address)s</strong></p>\n                <p>Contact phone: <strong>%(save_user_phone)s</strong></p>\n            </div>\n        </div>\n    </div>\n</body>\n</html>"
      },
      // 编辑模板相关
      editDialogVisible: false,
      emailTypeList: [],
      langList: [],
      currentTemplate: {
        id: '',
        name: '',
        subject: '',
        language: '',
        content: '',
        updated_at: ''
      },
      detailDialogVisible: false,
      currentDetailContent: ''
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getUserInfo();
    this.getLangDictValue();
    this.getEmaliTypeDictValue();
    this.fetchDevices();
  },
  methods: {
    // 获取设备列表
    fetchDevices: function fetchDevices() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request({
                  method: 'post',
                  url: '/api/device/index',
                  data: {
                    "device_number": "",
                    "market_mobile": _this.userInfo.phone,
                    "start_time": "",
                    "end_time": "",
                    "page": 1,
                    "page_size": 10,
                    "order_column_name": "",
                    "order_type": ""
                  }
                }).then(function (res) {
                  _this.deviceList = res.list;
                  _this.deviceTotal = res.total;
                  console.log('fetchDevices-----------', res);
                }).catch(function (error) {
                  console.error('获取设备列表失败:', error); // 模拟数据（实际使用时删除）

                  _this.deviceTotal = 2;
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleDeviceSizeChange: function handleDeviceSizeChange(val) {
      this.devicePageSize = val;
      this.fetchDevices();
    },
    handleDeviceCurrentChange: function handleDeviceCurrentChange(val) {
      this.deviceCurrentPage = val;
      this.fetchDevices();
    },
    editDevice: function editDevice(device) {
      this.currentDevice = _objectSpread({}, device);
      console.log(device);
      this.currentDevice.email_send = this.currentDevice.email_send == 1 ? true : false;
      this.deviceDialogVisible = true;
    },
    updateDevice: function updateDevice() {
      var _this2 = this;

      console.log('this.currentDevice.email_send', this.currentDevice.email_send);
      request({
        method: 'put',
        url: '/api/device/update',
        data: _objectSpread(_objectSpread({}, this.currentDevice), {}, {
          'device_id': this.currentDevice.device_id,
          'device_name': this.currentDevice.device_name,
          'device_address': this.currentDevice.device_address,
          'email_send': this.currentDevice.email_send ? 1 : 0,
          'market_id': this.userInfo.market_id
        })
      }).then(function (res) {
        _this2.deviceDialogVisible = false;

        _this2.$message.success(_this2.$t('设备更新成功'));

        _this2.fetchDevices();
      }).catch(function (error) {
        console.error('更新设备失败:', error);

        _this2.$message.error(_this2.$t('更新失败'));
      });
    },
    showDetail: function showDetail(content) {
      this.currentDetailContent = content;
      this.detailDialogVisible = true;
    },
    // 获取字典值
    getLangDictValue: function getLangDictValue(dict_id, dict_value) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this3;
                request({
                  method: 'post',
                  url: '/api/dictData/index',
                  data: {
                    'dict_id': 102
                  }
                }).then(function (res) {
                  _this3.langList = res.list;
                  console.log('getDictValue', res.list);
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getEmaliTypeDictValue: function getEmaliTypeDictValue(dict_id, dict_value) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this4;
                request({
                  method: 'post',
                  url: '/api/dictData/index',
                  data: {
                    'dict_id': 103
                  }
                }).then(function (res) {
                  _this4.emailTypeList = res.list;
                  console.log('getDictValue', res.list);
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getUserInfo: function getUserInfo() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this5;
                _context4.next = 3;
                return _this5.$store.dispatch('d2admin/db/get', {
                  dbName: 'sys',
                  path: 'user.info',
                  defaultValue: {},
                  user: true
                }, {
                  root: true
                });

              case 3:
                _this5.userInfo = _context4.sent;

                _this5.getList();

                _this5.fetchTemplates();

                console.log('---------------userinfo sms', _this5.userInfo);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getEmailConfig: function getEmailConfig() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                request({
                  method: 'post',
                  url: '/api/market/update/email/set/',
                  data: {
                    'id': _this6.userInfo.market_id
                  }
                }).then(function (res) {
                  console.log('getEmailConfig', res);
                  _this6.emailConfig.smtpPort = res.email_port;
                  _this6.emailConfig.smtpHost = res.email_host;
                  _this6.emailConfig.email = res.email;
                  _this6.emailConfig.email_password = res.email_password;
                });

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    fetchTemplates: function fetchTemplates() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                request({
                  method: 'post',
                  url: '/api/email-template-set/index',
                  data: {
                    'market_id': _this7.userInfo.market_id,
                    'page': _this7.templateCurrentPage,
                    'page_size': _this7.templatePageSize
                  }
                }).then(function (res) {
                  _this7.templateList = res.list;
                  console.log('fetchTemplates-----------', res);
                });

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    handleTemplateSizeChange: function handleTemplateSizeChange(val) {
      this.templatePageSize = val;
      this.fetchTemplates();
    },
    handleTemplateCurrentChange: function handleTemplateCurrentChange(val) {
      this.templateCurrentPage = val;
      this.fetchTemplates();
    },
    addTemplate: function addTemplate() {
      this.createDialogVisible = true;
    },
    editTemplate: function editTemplate(template) {
      this.currentTemplate = _objectSpread({}, template);
      this.editDialogVisible = true;
    },
    saveNewTemplate: function saveNewTemplate() {
      var _this8 = this;

      if (!this.newTemplate.email_title) {
        this.$message.error(this.$t('请输入模板名称'));
        return;
      }

      request({
        method: 'put',
        url: '/api/email-template-set/create',
        data: {
          'market_id': this.userInfo.market_id,
          'email_type': 'notification',
          'email_language': this.newTemplate.email_language,
          'email_title': this.newTemplate.email_title,
          'email_keys': this.newTemplate.email_keys,
          'email_template': this.newTemplate.email_template
        }
      }).then(function (res) {
        _this8.createDialogVisible = false;

        _this8.$message.success(_this8.$t('模板创建成功')); // 重置表单


        _this8.newTemplate = {
          email_keys: '{"pick_code": "", "device_address": "", "save_user_phone":""}',
          email_title: 'Pick Code',
          email_type: 'Send code',
          email_language: 'en',
          email_template: '[BWZN]Pickup code %(pick_code)s,Please collect your key via smart locker at %(device_address)s tel:%(save_user_phone)s'
        };

        _this8.getList();
      });
    },
    updateTemplate: function updateTemplate() {
      var _this9 = this;

      if (!this.currentTemplate.email_title) {
        this.$message.error(this.$t('请输入模板名称'));
        return;
      }

      request({
        method: 'put',
        url: '/api/email-template-set/update',
        data: {
          "id": this.currentTemplate.id,
          'market_id': this.userInfo.market_id,
          'email_type': this.currentTemplate.email_type,
          'email_language': this.currentTemplate.email_language,
          'email_title': this.currentTemplate.email_title,
          'email_keys': this.currentTemplate.email_keys,
          'email_template': this.currentTemplate.email_template
        }
      }).then(function (res) {
        _this9.editDialogVisible = false;

        _this9.$message.success(_this9.$t('模板更新成功'));

        _this9.getList();
      });
    },
    deleteTemplate: function deleteTemplate(template) {
      var _this10 = this;

      this.$confirm(this.$t("\u786E\u5B9A\u8981\u5220\u9664\u5417?"), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(function () {
        request({
          method: 'delete',
          url: '/api/email-template-set/delete',
          data: {
            "id": template.id
          }
        }).then(function (res) {
          _this10.$message.success(_this10.$t('删除成功'));

          _this10.fetchTemplates();
        });
      }).catch(function () {});
    },
    // 获取列表
    getList: function getList(startDate, endDate, email_type) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('获取列表');
                request({
                  method: 'post',
                  url: '/api/email-record/index',
                  data: {
                    'market_id': _this11.userInfo.market_id,
                    'page': _this11.currentPage,
                    'page_size': _this11.pageSize,
                    'user_email': _this11.queryForm.user_email ? _this11.queryForm.user_email : '',
                    'start_time': startDate ? startDate : '',
                    'end_time': endDate ? endDate : '',
                    'email_type': email_type ? email_type : ''
                  }
                }).then(function (res) {
                  _this11.emailList = res.list;
                  console.log('record---------------', res);
                });

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    resetQuery: function resetQuery() {
      this.queryForm = {
        user_email: '',
        dateRange: ''
      };
      this.getList();
    },
    handleTabClick: function handleTabClick(tab, event) {
      if (tab.name == 'config') {
        this.getEmailConfig();
      } else if (tab.name == 'template') {
        this.fetchTemplates();
      } else if (tab.name == 'email') {
        this.getList();
      } else if (tab.name == 'device') {
        this.fetchDevices(); // 新增设备列表获取
      }

      console.log('切换到标签:', tab.name);
    },
    saveConfig: function saveConfig() {
      request({
        method: 'put',
        url: '/api/market/update/email/set/',
        data: {
          'id': this.userInfo.market_id,
          'email': this.emailConfig.email,
          'email_password': this.emailConfig.email_password,
          'email_host': this.emailConfig.smtpHost,
          'email_port': this.emailConfig.smtpPort
        }
      }).then(function (res) {
        console.log('保存成功', res);
      });
      this.$message.success('配置已保存');
    },
    testConfig: function testConfig() {
      this.$message.info('开始测试连接...');
    },
    onQuery: function onQuery() {
      var startDate;
      var endDate;

      if (this.queryForm.dateRange && this.queryForm.dateRange.length === 2) {
        startDate = this.formatDate(this.queryForm.dateRange[0]);
        endDate = this.formatDate(this.queryForm.dateRange[1]);
        console.log('开始日期:', startDate); // 例如: 2024-01-01T00:00:00Z

        console.log('结束日期:', endDate); // 例如: 2024-12-31T00:00:00Z
      }

      this.getList(startDate, endDate, this.queryForm.email_type);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    formatDate: function formatDate(date) {
      var utcDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      return utcDate.toISOString().replace(/\.\d{3}/, '');
    }
  }
};